const table = [
  [
    {
      title: "国家/地区/组织",
      row: 1,
      col: 1,
      bold: true,
    },
    {
      title: "内容",
      row: 1,
      col: 2,
      bold: true,
    },
    // {
    //   title: "网址",
    //   row: 1,
    //   col: 1,
    //   bold: true,
    // },
  ],
  [
    {
      title: "中国",
      row: 9,
      col: 1,
    },
    {
      title: "国家知识产权局",
      row: 1,
      col: 2,
      link: "http://www.cnipa.gov.cn/",
    }
  ],
  [
    {
      title: "国家知识产权局专利公布公告",
      row: 1,
      col: 2,
      link: "http://epub.cnipa.gov.cn/",
    },
  ],
  [
    {
      title: "中国及多国审查信息查询",
      row: 1,
      col: 2,
      link: "https://cpquery.cponline.cnipa.gov.cn",
    },
  ],
  [
    {
      title: "国际专利分类号检索系统",
      row: 1,
      col: 2,
      link: "http://epub.cnipa.gov.cn/Ipc",
    },
  ],
  // [
  //   {
  //     title: "中国国家知识产权局专利复审委",
  //     row: 1,
  //     col: 2,
  //     link: "http://reexam.cnipa.gov.cn/",
  //   },
  // ],
  // [
  //   {
  //     title: "CNIPA中国国家知识产权局专利检索及分析系统",
  //     row: 1,
  //     col: 2,
  //     link: "http://pss-system.cnipa.gov.cn/sipopublicsearch/portal/uiIndex.shtml",
  //   }
  // ],
  [
    {
      title: "国家知识产权公共服务网",
      row: 1,
      col: 2,
      link: "http://ggfw.cnipa.gov.cn:8010/PatentCMS_Center/",
    },
  ],
  [
    {
      title: "中国香港",
      row: 1,
      col: 1,
    },
    {
      title: "香港知识产权局",
      row: 1,
      col: 1,
      link: "http://www.ipd.gov.hk/",
    }
  ],
  [
    {
      title: "广东省",
      row: 2,
      col: 1,
    },
    {
      title: "广东省知识产权公共信息综合服务平台",
      row: 1,
      link: "https://s.gpic.gd.cn/route/hostingplatform/search/searchIndex",
      col: 1,
    },
  ],
  [
    {
      title: "广东省知识产权大数据业务智能系统",
      row: 1,
      col: 1,
      link: "https://bigdata.gpic.gd.cn/",
    },
  ],
  [
    {
      title: "粤港澳地区",
      row: 1,
      col: 1,
    },
    {
      title: "粤港澳知识产权大数据综合服务平台",
      row: 1,
      col: 2,
      link: "https://www.gpic.gd.cn/",
    },
  ],
  [
    {
      title: "世界知识产权组织",
      row: 4,
      col: 1,
    },
    {
      title: "世界知识产权组织局",
      row: 1,
      col: 2,
      link: "http://www.wipo.int/portal/en/",
    },
  ],
  [
    {
      title: "电子申请ePCT",
      row: 1,
      col: 2,
      link: "https://pct.wipo.int/LoginForms/epct.jsp",
    },
  ],
  [
    {
      title: "检索系统",
      row: 1,
      col: 2,
      link: "https://patentscope.wipo.int/search/en/search.jsf",
    },
  ],
  [
    {
      title: "国际专利分类号检索系统",
      row: 1,
      col: 2,
      link: "http://www.wipo.int/ipcpub/",
    },
  ],
  [
    {
      title: "美国",
      row: 8,
      col: 1,
    },
    {
      title: "美国知识产权局",
      row: 1,
      col: 2,
      link: "http://www.uspto.gov",
    },
  ],
  [
    {
      title: "电子申请系统",
      row: 1,
      col: 2,
      link: "https://efs.uspto.gov/EFSWebUIUnregistered/EFSWebUnregistered",
    },
  ],
  [
    {
      title: "检索系统",
      row: 6,
      col: 1,
    },
  ],
  // [
  //   {
  //     title: "专利全文文本和图像数据库（PatFT）",
  //     row: 1,
  //     col: 1,
  //     link: "http://patft.uspto.gov/netahtml/PTO/index.html",
  //   },

  // ],
  // [
  //   {
  //     title: "专利申请全文文本和图像数据库（AppFTP）",
  //     row: 1,
  //     col: 1,
  //     link: "http://appft.uspto.gov/netahtml/PTO/index.html",
  //   },
  // ],
  // [
  //   {
  //     title: "全球专利搜索网站（GPSN）",
  //     row: 1,
  //     col: 1,
  //     link: "http://gpsn.uspto.gov/",
  //   },
  // ],
  [
    {
      title: "专利申请信息检索平台（PAIR）",
      row: 1,
      col: 1,
      link: "https://www.uspto.gov/patents/apply/checking-application-status/check-filing-status-your-patent-application",
    },
  ],
  [
    {
      title: "共同引用文献检索平台",
      row: 1,
      col: 1,
      link: "http://ccd.fiveipoffices.org/CCD-2.0.8/",
    },
  ],
  [
    {
      title: "外国专利局搜索平台",
      row: 1,
      col: 1,
      link: "http://www.uspto.gov/patents-application-process/search-patents#heading-1",
    },
  ],
  [
    {
      title: "公开序列检索中心",
      row: 1,
      col: 1,
      link: "http://seqdata.uspto.gov/",
    },
  ],
  [
    {
      title: "专利转让数据库",
      row: 1,
      col: 1,
      link: "http://assignment.uspto.gov/",
    },
  ],
  [
    {
      title: "日本",
      row: 2,
      col: 1,
    },
    {
      title: "日本知识产权局",
      row: 1,
      col: 2,
      link: "http://www.jpo.go.jp/",
    },
  ],
  [
    {
      title: "日本专利信息平台",
      row: 1,
      col: 2,
      link: "https://www.j-platpat.inpit.go.jp/",
    },
  ],
  [
    {
      title: "欧洲",
      row: 5,
      col: 1,
    },
    {
      title: "欧洲知识产权局",
      row: 1,
      col: 2,
      link: "http://www.epo.org/",
    },
  ],
  [
    {
      title: "检索系统",
      row: 4,
      col: 1,
    },
  ],
  [
    {
      title: "欧洲专利局专利检索",
      row: 1,
      col: 1,
      link: "https://worldwide.espacenet.com/",
    },
  ],
  [
    {
      title: "欧洲公开服务器",
      row: 1,
      col: 1,
      link: "https://data.epo.org/publication-server/?lg=en",
    },
  ],
  [
    {
      title: "专利登记",
      row: 1,
      col: 1,
      link: "https://register.epo.org/regviewer",
    },
  ],
  [
    {
      title: "韩国",
      row: 2,
      col: 1,
    },
    {
      title: "韩国知识产权局",
      row: 1,
      col: 2,
      link: "https://www.kipo.go.kr/",
    },
  ],
  [
    {
      title: "检索系统",
      row: 1,
      col: 2,
      link: "http://www.kipris.or.kr/enghome/main.jsp",
    },
  ],
  [
    {
      title: "澳大利亚",
      row: 2,
      col: 1,
    },
    {
      title: "澳大利亚知识产权局",
      row: 1,
      col: 2,
      link: "http://www.ipaustralia.gov.au/",
    },
  ],
  [
    {
      title: "专利检索系统",
      row: 1,
      col: 2,
      link: "https://www.ipaustralia.gov.au/patents/search-existing-patents",
    },
  ],
  [
    {
      title: "巴西",
      row: 1,
      col: 1,
    },
    {
      title: "巴西知识产权局",
      row: 1,
      col: 2,
      link: "http://www.inpi.gov.br/",
    },
  ],
  [
    {
      title: "德国",
      row: 2,
      col: 1,
    },
    {
      title: "德国知识产权局",
      row: 1,
      col: 2,
      link: "http://www.dpma.de/",
    },
  ],
  [
    {
      title: "检索系统",
      row: 1,
      col: 2,
      link: "https://register.dpma.de/DPMAregister/Uebersicht",
    },
  ],
  [
    {
      title: "俄罗斯",
      row: 2,
      col: 1,
    },
    {
      title: "俄罗斯知识产权局",
      row: 1,
      col: 2,
      link: "http://www.fips.ru/",
    },
  ],
  [
    {
      title: "检索系统",
      row: 1,
      col: 2,
      link: "http://www1.fips.ru/wps/wcm/connect/content_en/en/informational_resources/article_entr_irs_en_new",
    },
  ],
  [
    {
      title: "加拿大",
      row: 2,
      col: 1,
    },
    {
      title: "加拿大知识产权局",
      row: 1,
      col: 2,
      link: "http://www.ic.gc.ca/eic/site/cipointernet-internetopic.nsf/eng/home",
    },
  ],
  [
    {
      title: "检索系统",
      row: 1,
      col: 2,
      link: "https://www.ic.gc.ca/opic-cipo/cpd/eng/introduction.html",
    },
  ],
  [
    {
      title: "马拉西亚",
      row: 1,
      col: 1,
    },
    {
      title: "马拉西亚知识产权局",
      row: 1,
      col: 2,
      link: "http://www.myipo.gov.my/",
    },
  ],
  [
    {
      title: "新西兰",
      row: 2,
      col: 1,
    },
    {
      title: "新西兰知识产权局",
      row: 1,
      col: 2,
      link: "https://www.iponz.govt.nz/",
    },
  ],
  [
    {
      title: "检索系统",
      row: 1,
      col: 2,
      link: "http://www.iponz.govt.nz/app/Extra/Default.aspx?sid=635818379713557230",
    },
  ],
  [
    {
      title: "英国",
      row: 2,
      col: 1,
    },
    {
      title: "英国知识产权局",
      row: 1,
      link: "https://www.gov.uk/government/organisations/intellectual-property-office",
      col: 2,
    },
  ],
  [
    {
      title: "检索系统",
      row: 1,
      col: 2,
      link: "https://www.ipo.gov.uk/p-ipsum.htm",
    },
  ],
  [
    {
      title: "越南",
      row: 1,
      col: 1,
    },
    {
      title: "越南知识产权局",
      row: 1,
      col: 2,
      link: "http://www.noip.gov.vn/",
    },
  ]
];

export { table };
